module.exports = __webpack_public_path__ + "static/media/S (99).72c12bff.jpg";